import { createFileRoute } from '@tanstack/react-router';
import { AdminSettlementPage } from '../../features/settlement';

export const Route = createFileRoute('/admin/settlement')({ component: AdminSettlementPage });
